import "./bootstrap";
import "../css/app.css";
import * as Sentry from "@sentry/react";


import {LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import {createRoot} from "react-dom/client";
import {createInertiaApp} from "@inertiajs/react";
import {resolvePageComponent} from "laravel-vite-plugin/inertia-helpers";
import {ThemeProvider} from "@emotion/react";
import {theme, brand} from "@/Utils/Theme";
import {CssBaseline} from "@mui/material";

const appName = import.meta.env.VITE_APP_NAME || "Laravel";

// Initialize Sentry only in production environment
if (import.meta.env.VITE_APP_ENV === 'production') {
    Sentry.init({
        dsn: "https://c46065c2fedbeb2b2b1e34a718323d62@o4509562667466752.ingest.us.sentry.io/4509562671333376",
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
        ],
        // Performance Monitoring
        tracesSampleRate: 1.0, //  Capture 100% of the transactions
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ["localhost", "yocompito.test", "beta.yocompito.com", "yocompito.com"],
        // Set release to match build-time release
        release: import.meta.env.VITE_SENTRY_RELEASE,
        // Session Replay
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
}


createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) =>
        resolvePageComponent(
            `./Pages/${name}.tsx`,
            import.meta.glob("./Pages/**/*.tsx")
        ),
    setup({el, App, props}) {
        const root = createRoot(el);
        const appContent = (
            <ThemeProvider theme={theme}>
                <CssBaseline/>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <App {...props} />
                </LocalizationProvider>
            </ThemeProvider>
        );

        // Only wrap with Sentry ErrorBoundary in production
        const finalContent = import.meta.env.VITE_APP_ENV === 'production'
            ? <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>{appContent}</Sentry.ErrorBoundary>
            : appContent;

        root.render(finalContent);
    },
    progress: {
        color: brand.amarillo,
    },
}).then(() => {
})
